module.exports = __webpack_public_path__ + "static/media/library.674e3dd2.svg";